export const ageMethod = "age nearest";
export const gateway = "https://qat-oraclerms-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/oraclerms";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJvcmFjbGVybXMiLCJuYW1lIjoib3JhY2xlcm1zIiwiaWF0IjoxNzgwNTgzNzA4LCJleHAiOjE5MzgzNzE3MDh9.yrNPJYJQwuictOpBL4wHkt3Du28a5rP6Ppm7pKnR1P8";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-oraclerms-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_oraclerms",
			brands: [
				"qat-oraclerms-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "oraclerms",
			broker_formatted_name: "Oracle RMS",
			email: "life@oraclerms.com",
			environment: "qat",
			environment_id: "qat",
			g4: "G-K79QEMGKPC",
			layout: "iframe",
			logoPosition: "menu",
			map1: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map2: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map3: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map4: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			menuPhone: "button",
			phone: "1-855-884-6150",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://www.oraclerms.com/privacy/",
			tagline: "Reduce Your Risk",
			themeSwitcher: "hide",
			website: "https://www.oraclerms.com/",
			scope: "oraclerms#branding#qat-oraclerms-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-oraclerms-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_oraclerms",
			brands: [
				"qat-oraclerms-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "oraclerms",
			broker_formatted_name: "Oracle RMS",
			email: "life@oraclerms.com",
			environment: "qat",
			environment_id: "qat",
			g4: "G-K79QEMGKPC",
			layout: "iframe",
			logoPosition: "menu",
			map1: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map2: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map3: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			map4: [
				"100 Drumlin Circle",
				"Concord",
				"ON",
				"L4K 3E5",
			],
			menuPhone: "button",
			phone: "1-855-884-6150",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://www.oraclerms.com/privacy/",
			tagline: "Reduce Your Risk",
			themeSwitcher: "hide",
			website: "https://www.oraclerms.com/",
			scope: "oraclerms#branding#qat-oraclerms-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-oraclerms-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:35:08 GMT+0000 (Coordinated Universal Time)
